(function ($, _) {

	// *************************************************************************
	// Recaptcha form
	// *************************************************************************

	function RecaptchaForm(form, options) {
		this.ajaxForm = new _.story.AjaxForm(form, options);
		this.ajaxForm.clearCallback = this.clearRecaptcha.bind(this);
		this.recaptchaSiteKey = this.ajaxForm.$submitButton.data("sitekey");
		this.recaptchaWidget = null;
		this.isRecaptchaEnabled = (this.recaptchaSiteKey ? true : false);
		this.$recaptchaFormGroup = null;
	}
	RecaptchaForm.prototype = {
		constructor: RecaptchaForm,

	// Public:

		//
		// Build form elements
		//
		build: function() {
			if (this.isRecaptchaEnabled) {
				// Wrap submit button into form group
				this.$recaptchaFormGroup = $("<div class='form-group' data-af-field='recaptcha'><div class='recaptcha-input-field'></div></div>");

				$formGroup = this.ajaxForm.$submitButton.closest(".form-group");
				if ($formGroup.length) {
					this.$recaptchaFormGroup.insertBefore($formGroup);
				}
				else {
					this.$recaptchaFormGroup.insertBefore(this.ajaxForm.$submitButton);
				}

				// Set up events to load recaptcha library
				this.ajaxForm.$form.find("input, textarea, button, select").focus(this.loadRecaptchaLibrary.bind(this));
			}

			this.ajaxForm.build();
		},

		//
		// Activate AJAX on form
		//
		activate: function() {
			if (!this.isRecaptchaEnabled) {
				// Active AJAX by regular ajax form
				this.ajaxForm.activate();
			}
		},

		activateRecaptcha: function() {
			if (!this.isRecaptchaEnabled) {
				return;
			}

			var self = this;

			this.ajaxForm.$submitButton.attr("size", "invisible");

			// Create recaptcha widget, if not exists.
			this.recaptchaWidget = grecaptcha.render(this.$recaptchaFormGroup.find(".recaptcha-input-field").get(0), {
				sitekey: self.recaptchaSiteKey,
				callback: self.ajaxForm.submit.bind(self.ajaxForm),
				size: "invisible",
			});

			this.ajaxForm.$submitButton.click(function(e) {
				e.preventDefault();

				if (self.ajaxForm.isFormEnabled()) {
					self.ajaxForm.disableForm();

					self.ajaxForm.log("Sending recaptcha request.")
					var token = grecaptcha.getResponse(self.recaptchaWidget);
					if (!token) {
						self.ajaxForm.log("Executing recaptcha.")
						grecaptcha.execute(self.recaptchaWidget);
					}
				} else {
					self.ajaxForm.log("Form is disabled.")
				}
			});

			// Enable clicking on submit button
			this.setSubmitButtonState();
		},


	// Protected:

		clearRecaptcha: function() {
			// Reset recatpcha
			if (this.isRecaptchaEnabled) {
				this.ajaxForm.log("Clearing recaptcha.");
				grecaptcha.reset(this.recaptchaWidget);
			}
		},

		loadRecaptchaLibrary: function() {
			if (_.story.isRecaptchaLibraryLoaded) { return; }

			// Prevent clicking on submit button
			this.setSubmitButtonState();

			var self = this;
			var head = document.getElementsByTagName("head")[0];
			var script = document.createElement("script");

			if (script.attachEvent) {
				script.attachEvent("onreadystatechange", function(event) {
					var elm = event.srcElement;
					if (elm.readyState == "loaded" || elm.readyState == "complete") { self.onRecaptchaLibraryLoaded(); }
				});
			} else {
				script.addEventListener("load", this.onRecaptchaLibraryLoaded.bind(this), false);
			}

			var language = $("html").attr("lang");
			language = language ? ("&hl=" + language) : "";

			script.charset = "utf-8";
			script.type = "text/javascript";
			script.src = "https://www.google.com/recaptcha/api.js?render=explicit&onload=recaptchaForm" + language;

			head.appendChild(script);

			_.story.isRecaptchaLibraryLoaded = true;
		},

		onRecaptchaLibraryLoaded: function() {
			// This event can be ommited, recaptcha call our explicit function recaptchaForm
		},

		setSubmitButtonState: function() {
			if (_.story.isRecaptchaLibraryLoaded) {
				this.ajaxForm.$submitButton.prop("disabled", false);
				this.ajaxForm.$form.removeClass("af-sending-request");
			}
			else {
				this.ajaxForm.$submitButton.prop("disabled", true);
				this.ajaxForm.$form.addClass("af-sending-request");
			}
		}

	};


	// *************************************************************************
	// jQuery plugin
	// *************************************************************************

	$.recaptchaForm = function(options) {
		$("[data-af]").recaptchaForm(options);
	}

	$.fn.recaptchaForm = function(options) {
		$(this).each(function() {
			var $this = $(this);
			if (!$this.data("recaptchaForm")) {
				var opts = $.extend({}, $.ajaxForm.defaults, options);

				var recaptchaForm = new RecaptchaForm(this, opts);
				$this.data("recaptchaForm", recaptchaForm);

				recaptchaForm.build();
				recaptchaForm.activate();
			}
		});
	}

	// This function is called from within focus event on already initialized RecaptchaForm.
	_.recaptchaForm = function() {
		$("[data-af]").each(function() {
			var $this = $(this);
			var recaptchaForm = $this.data("recaptchaForm");
			if (recaptchaForm) {
				recaptchaForm.activateRecaptcha();
			}
		});
	}


	// *************************************************************************
	// Public interface
	// *************************************************************************

	if (!_.story) { _.story = {}; }
	_.story.isRecaptchaLibraryLoaded = false;

}(jQuery, window));
